import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {publicApi} from '../api';

export default function SignedDocumentPage() {
  const {token} = useParams();
  const [status, setStatus] = useState('loading'); // loading | redirecting | expired | sent | error
  const [sending, setSending] = useState(false);

  useEffect(() => {
    publicApi(`/esign/sign/${token}/document`).then(r => {
      if (r.ok) {
        r.json().then(data => {
          setStatus('redirecting');
          window.location.href = data.url;
        });
      } else if (r.status === 410) {
        setStatus('expired');
      } else {
        setStatus('error');
      }
    });
  }, [token]);

  const handleResend = async () => {
    setSending(true);
    await publicApi(`/esign/sign/${token}/document/resend`, {method: 'POST'});
    setSending(false);
    setStatus('sent');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center bg-white rounded-lg shadow-lg p-8 max-w-md mx-4">
        <div className="mb-6">
          <img src="/images/mydocumentsign-logo.png" alt="MyDocumentSign" className="h-7 mx-auto" />
        </div>

        {status === 'loading' && (
          <p className="text-gray-500">Loading document...</p>
        )}

        {status === 'redirecting' && (
          <p className="text-gray-500">Opening document...</p>
        )}

        {status === 'expired' && (
          <>
            <div className="text-4xl mb-4">⏱</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Link Expired</h1>
            <p className="text-gray-500 mb-6">
              This download link has expired. We can send you a fresh link to access your document.
            </p>
            <button onClick={handleResend} disabled={sending}
              className="px-6 py-2.5 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 font-medium text-sm disabled:opacity-50">
              {sending ? 'Sending...' : 'Send New Link'}
            </button>
          </>
        )}

        {status === 'sent' && (
          <>
            <div className="text-4xl mb-4">✉️</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">New Link Sent</h1>
            <p className="text-gray-500">
              We've sent a fresh download link to your email. Please check your inbox.
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-4xl mb-4">⚠️</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Document Not Found</h1>
            <p className="text-gray-500">
              This link is invalid or the document is no longer available.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
